import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getAcmgTranscript } from "../../../../../state/selectors/Pulsar.selectors";
import { getGenome } from "../../../../../state/selectors/general.selectors";
import Transcript from "../models/Transcript";
import Exon from "../models/Exon";
import Codon from "../models/Codon";
import HaploTriploTable from "./HaploTriploTable";
import store from "../../../../../state/store";

function TranscriptInfo({ item, actions, acmgTranscript }) {
  if (!item) return null;

  const { varsomeHost } = store.getState();
  const { transcript } = item;
  const { genomeId } = transcript.region.chromosome;
  const haploPubIds = (transcript.haploInsPubs || []).filter(Boolean);
  const triploPubIds = (transcript.triploSenPubs || []).filter(Boolean);
  const isACMG = acmgTranscript === transcript?.transcriptName;

  return (
    <div className="tw-min-w-66">
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          <a
            href={`${varsomeHost}/transcript/${genomeId}/${transcript.transcriptName}`}
            target="_blank"
          >
            {transcript.transcriptName}
          </a>
        </div>
        {actions}
      </div>

      <div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Gene Symbol</div>
          <div className="">{transcript.geneSymbol}</div>
        </div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Database</div>
          <div className="">
            <a target="_blank" href={transcript.getLink()}>
              {transcript.db}
            </a>
          </div>
        </div>
        {transcript.isEnsembl ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-24">Support Level</div>
            <div className="">{transcript.tsl || "-"}</div>
          </div>
        ) : null}

        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Size</div>
          <div className="">{transcript.region.size.toLocaleString()} bp</div>
        </div>

        <HaploTriploTable
          type="Haploinsufficiency"
          desc={transcript.haploInsDesc}
          score={transcript.haploInsScore}
          pubs={haploPubIds.map((x) => x.toString())}
        />

        <HaploTriploTable
          type="Triplosensitivity"
          desc={transcript.triploSenDesc}
          score={transcript.triploSenScore}
          pubs={triploPubIds.map((x) => x.toString())}
        />
      </div>

      <div className="tw-opacity-80 tw-italic">
        {isACMG
          ? "Transcript used in the Germline Classification component"
          : ""}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    genomeId: getGenome(state).name,
    acmgTranscript: getAcmgTranscript(state),
  };
};

TranscriptInfo.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.instanceOf(Transcript),
    PropTypes.instanceOf(Exon),
    PropTypes.instanceOf(Codon),
  ]).isRequired,
  actions: PropTypes.node,
  acmgTranscript: PropTypes.string,
};

TranscriptInfo.defaultProps = {
  actions: null,
  acmgTranscript: null,
};

export default connect(mapStateToProps)(TranscriptInfo);
